import {
    formatDateNoTime,
    formatYDM,
    getToken,
    getToken2,
    getUser,
    numberFormatInt
} from "../../Utils/Common";
import Moment from "moment";
import { getAPICall, postAPICall } from "../axiosMethodCalls";

export const getStoreDeposit = async (id) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "store_deposits/get",
            {
                requester: getUser(),
                token: getToken(),
                store_deposit_id: id,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const getStoreDepositImage = async (id) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "store_deposits/get_image",
            {
                requester: getUser(),
                token: getToken(),
                store_deposit_id: id,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const searchStoreDeposit = async (data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "store_deposits/search",
            {
                requester: getUser(),
                token: getToken(),
                transaction_type: data.transaction_type,
                branch_id: data.branch_id,
                status: data.status,
                // branch_name: data.branch_name,
                wide_search: data.branch_name,
                deposited_to: data.bank_id,
                date_from: data.date_from ? Moment(data.date_from).format("YYYY-MM-DD") : "",
                date_to: data.date_to ? Moment(data.date_to).format("YYYY-MM-DD") : "",
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const createStoreDeposit = async (data) => {
    let form_data = new FormData();
    form_data.append("requester", getUser());
    form_data.append("token", getToken());
    form_data.append('date', data.date ? data.date : "");
    form_data.append('zcounter_id', data.zcounter_id ? data.zcounter_id : "");
    form_data.append('reference_no', data.reference_no ? data.reference_no : "");
    form_data.append('deposited_to', data.deposited_to ? data.deposited_to : "");
    form_data.append('deposited_on', data.deposited_on ? data.deposited_on : "");
    form_data.append('deposited_by', data.deposited_by ? data.deposited_by : "");

    data.attachments.map((file) => {
        form_data.append('attachments[]', file, file.name);
    });

    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "store_deposits/create", form_data
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const getZReading = async (data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "zcounters/get",
            {
                requester: getUser(),
                token: getToken(),
                date: data.date,
                zcounter_id: data.zcounter_id,
                branch_id: data.branch_id,
                is_deposited: data.is_deposited,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const updateStatusStoreDeposit = async (ids, status) => {
    
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "store_deposits/update_status",
            {
                requester: getUser(),
                token: getToken(),
                store_deposit_ids: ids.map((id) => {
                    return id.deposit_id;
                }),
                status: status,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const deleteStoreDeposit = async (id) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "store_deposits/delete",
            {
                requester: getUser(),
                token: getToken(),
                store_deposit_id: id,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

// --------------POTATO------------------

export const searchStoreDepositPotato = async (data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_POTATO + "store_deposits/search",
            {
                requester: getUser(),
                token: getToken2(),
                transaction_type: data.transaction_type,
                branch_id: data.branch_id,
                status: data.status,
                // branch_name: data.branch_name,
                wide_search: data.branch_name,
                deposited_to: data.bank_id,
                date_from: data.date_from ? Moment(data.date_from).format("YYYY-MM-DD") : "",
                date_to: data.date_to ? Moment(data.date_to).format("YYYY-MM-DD") : "",
            }, "potato"
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};


export const updateStatusStoreDepositPotato = async (ids, status) => {
    
    try {
        const response = await getAPICall(
            process.env.REACT_APP_POTATO + "store_deposits/update_status",
            {
                requester: getUser(),
                token: getToken2(),
                store_deposit_ids: ids.map((id) => {
                    return id.deposit_id;
                }),
                status: status,
            }, "potato"
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const getStoreDepositImagePotato = async (id) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_POTATO + "store_deposits/get_image",
            {
                requester: getUser(),
                token: getToken2(),
                store_deposit_id: id,
            }, "potato"
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const deleteStoreDepositPotato = async (id) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_POTATO + "store_deposits/delete",
            {
                requester: getUser(),
                token: getToken2(),
                store_deposit_id: id,
            }, "potato"
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};
